import React, { useEffect } from 'react';
import { useState } from 'react';
import RenewClubDetails from '../RenewMembership/RenewClubDetails';
import RenewGolfCourses from '../RenewMembership/RenewGolfCourses';
// import RenewPayment from './RenewPayment';
import RenewPayConfirmed from '../RenewMembership/RenewPayConfirmed';
import RenewPaymentExpired from './RenewPaymentExpired'
import AddCourses from '../../layout/AddedCoursesCard';
import CourseListSimple from '../../layout/CourseDetailsRenew';
const ExpiredRenewMembership = () => {
    // const [ScreenPostion, SetScreenPostion] = useState(1);
    // const [users, Setusers] = useState('');
    // const [reference_id, Setreference_id] = useState('');

    // useEffect(() => {
    //     project();
    // }, [ScreenPostion]);

    return (
        <>
<CourseListSimple/>

            {/* {
                (ScreenPostion === 1 && <RenewClubDetails      SetScreenPostion={SetScreenPostion}     />)
                || (ScreenPostion === 2 && <RenewGolfCourses      SetScreenPostion={SetScreenPostion}  Setusers={Setusers}   />)
                 (ScreenPostion === 1 && <RenewPaymentExpired      SetScreenPostion={SetScreenPostion}  users={users} Setreference_id={Setreference_id}  />)
                || (ScreenPostion === 2 && <RenewPayConfirmed      SetScreenPostion={SetScreenPostion}  reference_id={reference_id}    />)
                // || <h1>Something Else</h1>
            } */}
        </>
    )
}

export default ExpiredRenewMembership;
